"use client";
import React from "react";
import {TextRevealCard} from "../ui/text-reveal-card.tsx";

export function TextRevealCardPreview() {
  return (
  
      <TextRevealCard
        text="Software Developer"
        revealText="Frontend Focused..."
      >
      </TextRevealCard>
  );
}
